export default __webpack_public_path__ + "static/media/KFCRewards.ea5060f1.svg";